export default __webpack_public_path__ + "static/media/medical-insurance.0d0aa603.svg";